import { render, staticRenderFns } from "./CurrentSharing.vue?vue&type=template&id=72974fa7&"
import script from "./CurrentSharing.vue?vue&type=script&lang=js&"
export * from "./CurrentSharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports